import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

import { LanguageCodeEnum } from './shared/config/common/constants/lang';

export const routing = defineRouting({
  locales: [LanguageCodeEnum.RU, LanguageCodeEnum.KK],
  defaultLocale: LanguageCodeEnum.RU,
  localePrefix: 'as-needed',
});

export const { Link, redirect, usePathname, useRouter } = createNavigation(routing);
